<template>
    <div class="sustainable-component wage-individual-factors">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-individual-factors</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printIndividualFactors">Visa översikt över individuella tillägg</a>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Faktornr.</th>
                                <th class="col-3">Individfaktornamn</th>
                                <th class="col-3">Beräkningstyp</th>
                                <th class="col-2">Omfattning</th>
                                <th class="col-2"></th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in individualFactors" :key="index">
                                <td class="col-2">
                                    <span>{{item.FactorNumber}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{item.FactorName}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{getCalculationType(item.CalculationType)}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{getExtentType(item.Extent)}}</span>
                                </td>
                                <td class="col-2">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateFactor(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteFactor(item.IndividualFactorId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Gradnr.</th>
                                <th class="col-2" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">Fr.o.m.</th>
                                <th class="col-2" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">T.o.m.</th>
                                <th class="col-4">Beskrivning</th>
                                <th class="col-2">Poäng</th>
                                <th class="col-2"></th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in individualGrades" :key="index">
                                <td class="col-2">
                                    <span>{{item.GradeNumber}}</span>
                                </td>
                                <td class="col-2" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">
                                    <span>{{item.From}}</span>
                                </td>
                                <td class="col-2" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">
                                    <span>{{item.To}}</span>
                                </td>
                                <td class="col-4" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType == 0">
                                    <span>{{item.Description}}</span>
                                </td>
                                <td class="col-2">
                                    <span>{{item.Points}}</span>
                                </td>
                                <td class="col-2">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateGrade(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteGrade(item.IndividualFactorId, item.GradeNumber)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-form v-model="valid" ref="form1">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornummer" :rules="[nonExisting, rules.positiveInteger]" v-model="factorNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornamn" :rules="[rules.required]" v-model="factorName" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" :rules="[rules.requiredNumberWithZero]" label="Beräkningstyp" :items="calculationTypes" v-model="calculationType" item-title="name" item-value="val"></v-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" :rules="[rules.requiredNumberWithZero]" label="Omfattning" :items="extentTypes" v-model="selectedExtent" item-title="name" item-value="val"></v-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addFactor">
                                        Skapa faktor
                                    </v-btn>
                                </div>
                            </div>

                        </div>
                    </v-form>
                </div>
                <div class="col-12 col-md-6">
                    <v-form v-model="valid" ref="form2">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col">
                                    <v-select bg-color="white" variant="outlined" :rules="[rules.required]" label="Värderingsfaktor" :items="individualFactors" v-model="selectedFactor" item-title="FactorName" item-value="IndividualFactorId"></v-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Gradnummer" :rules="[rules.positiveInteger]" v-model="gradeNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Från och med" :rules="[rules.requiredNumberWithZero]" v-model="from" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row" v-if="selectedFactorObject != null && selectedFactorObject.CalculationType != 0">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Till och med" :rules="[rules.requiredNumberWithZero]" v-model="to" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Beskrivning" :rules="[rules.required]" v-model="description" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng" :rules="[rules.requiredNumberWithZero]" v-model="points" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addGrade">
                                        Skapa grad
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>

        <WageUpdateIndividualFactor v-bind:disabled="disabled" ref="updateIndividualFactor" @updated="load"></WageUpdateIndividualFactor>
        <WageUpdateIndividualGrade v-bind:disabled="disabled" ref="updateIndividualGrade" @updated="loadAfterGradeUpdate"></WageUpdateIndividualGrade>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import { getCurrentInstance } from 'vue'
    import WageUpdateIndividualFactor from "./update/update-individual-factor.vue"
    import WageUpdateIndividualGrade from "./update/update-individual-grade.vue"
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updateIndividualFactor = ref(null);
    const updateIndividualGrade = ref(null);
    const form1 = ref(null);
    const form2 = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-individual-factors',
        components: {
            WageUpdateIndividualFactor,
            WageUpdateIndividualGrade,
            CommonSpinner
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            updateFactor(item) {
                this.loading++;
                this.updateIndividualFactor.open(item);
                this.loading--;
            },
            updateGrade(item) {
                this.loading++;
                this.updateIndividualGrade.open(item);
                this.loading--;
            },
            getSelectedFactor(individualFactorId) {
                var result = null;
                for (var i = 0; i < this.individualFactors.length; i++) {
                    if (this.individualFactors[i].IndividualFactorId.toString() === individualFactorId.toString())
                        result = this.individualFactors[i];
                }
                return result;
            },
            async load() {
                this.loading++;
                try {
                    await this.loadFactors();
                    if (this.individualFactors.length > 0 && this.selectedFactor == null)
                        this.selectedFactor = this.individualFactors[0].IndividualFactorId;
                    await this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadAfterGradeUpdate() {
                this.loading++;
                try {
                    await this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadFactors() {
                this.loading++;
                try {
                    this.individualFactors = await WageService.getIndividualFactors();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadGrades(individualFactorId) {
                this.loading++;
                try {
                    this.individualGrades = await WageService.getIndividualGrades(individualFactorId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printIndividualFactors() {
                this.newWindow = window.open('/wagesettingsprint/printIndividualFactors', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async addFactor() { 
                var result = await this.form1.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await WageService.addIndividualFactor(this.factorNumber, this.factorName, this.calculationType, this.selectedExtent);
                    this.displaySnackBar("Sparat");
                    this.load();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            nonExisting(val){
                var exists = false;
                for (var i = 0; i < this.individualFactors.length; i++) {
                    if(this.individualFactors[i].FactorNumber.toString() === val.toString())
                        exists = true;
                }
                if(exists == false)
                    return true;
                return "Ange ett värde som inte är inlagt"
            },
            moreThan(val){
                var from = parseInt(this.from);
                var to = parseInt(val);
                if(from < to)
                return true;
                return "Ange ett värde större än " + from
            },
            async addGrade() {
                var result = await this.form2.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                if (this.selectedFactorObject.CalculationType == 0) {
                    this.from = 0;
                    this.to = 0;
                }
                try {
                    await WageService.addIndividualFactorGrade(this.selectedFactor, this.gradeNumber, this.from, this.to, this.description, this.points);
                    this.displaySnackBar("Sparat");
                    this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat, kontrollera gradnummer")
                }
                this.loading--;
            },
            async deleteFactor(individualFactorId) {
                if (confirm(" Är du säker att du vill radera faktorn?")) {
                    this.loading++;
                    try {
                        await WageService.deleteIndividualFactor(individualFactorId);
                        this.displaySnackBar("Borttaget");
                        this.load();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async deleteGrade(individualFactorGrade, gradeNumber) {
                if (confirm(" Är du säker att du vill radera graden?")) {
                    this.loading++;
                    try {
                        await WageService.deleteIndividualFactorGrade(individualFactorGrade, gradeNumber);
                        this.displaySnackBar("Borttaget");
                        this.loadGrades(this.selectedFactor);
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            getCalculationType(type) {
                var ret = "";
                for (var i = 0; i < this.calculationTypes.length; i++) {
                    if (this.calculationTypes[i].val == type)
                        ret = this.calculationTypes[i].short;
                }
                return ret;
            },
            getExtentType(type) {
                var ret = "";
                for (var i = 0; i < this.extentTypes.length; i++) {
                    if (this.extentTypes[i].val == type)
                        ret = this.extentTypes[i].short;
                }
                return ret;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                valid: false,
                rules: ValidationService.rules(),
                calculationTypes: [
                    { short: "Ingen", name: "0 - Ingen beräkning", val: 0 },
                    { short: "Anställningsd.", name: "1 - Anställningsdatum", val: 1 },
                    { short: "Anställd i y.", name: "2 - Anställd i yrket", val: 2 },
                ],
                extentTypes: [
                    { short: "Alla", name: "0 - Alla", val: 0 },
                    { short: "Individ.", name: "1 - Individ", val: 1 },
                ],
                selectedExtent:null,
                calculationType:null,
                factorNumber: null,
                factorName: null,
                selectedFactor: null,
                gradeNumber: null,
                from: null,
                to: null,
                points: null,
                selectedFactorObject: null,
                individualGrades:[],
                individualFactors:[],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedFactor: function (newVal) {
                this.loadGrades(newVal);
                this.selectedFactorObject = this.getSelectedFactor(newVal);
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.load();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateIndividualFactor, updateIndividualGrade, form1, form2 }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
